<template>
  <BaseLayout>
    <div class="kt-portlet" v-if="order">
      <div class="kt-portlet__body">

        <div class="kt-widget kt-widget--user-profile-3">
          <div class="kt-widget__top">
            <div class="kt-widget__content" style="padding-left: 0 !important;">
              <div class="kt-widget__head alert alert-primary" v-if="isQuoteSubmitted">
                <h5 v-if="!this.user.is_postpaid">Please review carefully and make the payment to proceed with the order: </h5>
                <button v-if="!this.user.is_postpaid" @click.prevent="placeStripeOrder" type="button" class="btn btn-danger btn-upper">
                  <i class="fa fa-credit-card"></i> <b>Accept Quotation</b>
                </button>

                <h5 v-if="this.user.is_postpaid">Please review carefully and accept to proceed with the order: </h5>
                <button v-if="this.user.is_postpaid" @click.prevent="acceptQuotation" type="button" class="btn btn-danger btn-upper">
                  <i class="fa fa-credit-card"></i> <b>Accept Quotation</b>
                </button>
              </div>
              <div class="kt-widget__head">

                <router-link :to="{name: 'order'}"  class="btn btn-sm btn-upper" style="background: rgb(237, 239, 246);">
                  <i class="flaticon2-fast-back"></i> Back </router-link>
                <div class="kt-widget__action">
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    v-if="isDraft(order) || isPending(order)"
                    @click.prevent="editOrder(order)"
                  >
                    <i class="flaticon-edit"></i> Edit
                  </button>
                  <DownloadOrderResultFiles
                    v-if="isComplete(order)"
                    :order="order"
                  />
                  <MessagesModal ref="messageModal" :order="order" />
                  <a
                    type="button"
                    class="btn btn-primary btn-sm btn-upper"
                    v-if="order.invoiceUrl"
                    :href="order.invoiceUrl"
                  >
                    <i class="flaticon2-file"></i> Invoice
                  </a>
                  <button
                    @click.prevent="placeStripeOrder"
                    type="button"
                    class="btn btn-brand btn-sm btn-upper"
                    v-if="showPayBtn"
                  >
                    Pay
                  </button>
                </div>

                <a href="#" class="kt-widget__title order-details-title">
                  {{ order.title }}
                </a>
              </div>

              <div class="kt-widget__info">
                <div class="pl-0 col-md-8 col-xl-8 kt-widget__desc">
                  <!-- {{ order.instruction }} -->
                  <span v-html="orderInstruction"></span>
                </div>

                <div class="kt-widget__stats d-flex align-items-start align-content-end flex-fill">
                  <div class="kt-widget__item">
                    <span class="kt-widget__date">Delivery Time</span>
                    <div class="kt-widget__label">
                      <span style="font-size: 1.5rem; font-weight: 500;">{{ order.delivery_time.title }}</span>
                    </div>
                  </div>
                  <div class="kt-widget__item">
                    <span class="kt-widget__date">
                      Start Date
                    </span>
                    <div class="kt-widget__label">
                      <span
                        class="btn btn-label-brand btn-sm btn-bold btn-upper"
                      >
                        {{ formatDate(order.create_date, "hh:mm, MMM DD") }}
                      </span>
                    </div>
                  </div>

                  <div class="kt-widget__item">
                    <span class="kt-widget__date">
                      Due Date
                    </span>
                    <div class="kt-widget__label">
                      <span
                        v-if="order.due_date"
                        class="btn btn-label-danger btn-sm btn-bold btn-upper"
                      >
                        {{ formatDate(order.due_date, "hh:mm, MMM DD") }}
                      </span>
                      <span class="btn" v-else>-</span>
                    </div>
                  </div>

                  <div class="kt-widget__item">
                    <span class="kt-widget__date">Order Total</span>
                    <div class="kt-widget__label">
                      <span style="font-size: 1.5rem; font-weight: 500;">{{
                        moneyFormat(order.total)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="kt-widget__bottom" style="margin: 0 !important;">
            <!-- Addons -->
            <div class="kt-widget__item" v-if="marginAddon">
              <div class="kt-widget__icon">
                <i class="flaticon-confetti"></i>
              </div>
              <div class="kt-widget__details">
                <span class="kt-widget__title">
                  {{ marginAddon.title }}
                </span>
                <span class="kt-widget__value" style="font-size: 1rem">
                  <span>T: {{ marginAddon.details.top }}, </span>
                  <span>B: {{ marginAddon.details.bottom }}, </span>
                  <span>L: {{ marginAddon.details.left }}, </span>
                  <span>R: {{ marginAddon.details.right }}</span>
                </span>
              </div>
            </div>

            <div class="kt-widget__item" v-if="websizeAddon">
              <div class="kt-widget__icon">
                <i class="flaticon-web"></i>
              </div>
              <div class="kt-widget__details">
                <span class="kt-widget__title">
                  Web Size
                </span>
                <span class="kt-widget__value" style="font-size: 1rem">
                  <span v-for="(websize, index) in websizeAddon" :key="index">
                    {{ websize.width }}x{{ websize.height }}
                    <span v-if="index + 1 !== websizeAddon.length">, </span>
                  </span>
                </span>
              </div>
            </div>
            <!-- /Addons -->

            <!-- Service Components -->
            <div
              class="kt-widget__item"
              v-for="service in order.service_components"
              :key="service.id"
            >
              <div class="kt-widget__icon">
                <i :class="getIcon(service.title)"></i>
              </div>
              <div class="kt-widget__details">
                <span class="kt-widget__title">
                  {{ service.title }}
                </span>
                <span class="kt-widget__value" style="font-size: 1rem">
                  <span
                    v-for="(option, index) in service.choices"
                    :key="option.id"
                  >
                    {{ option.choice }}
                    <span v-if="index + 1 !== service.choices.length">,</span>
                  </span>
                </span>
              </div>
            </div>
            <!-- /Service Components -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="order">
      <div class="col-xl-12">
        <div class="kt-portlet kt-portlet--height-fluid">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">
                Images ({{ order.images.length }})
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-section__content kt-section__content--solid">
              <div class="row">
                <div
                  class="col-xl-3 col-6 col-sm-4 col-md-3 mb-2"
                  v-for="image in order.images"
                  :key="image.id"
                  :title="imageTitle(image)"
                >
                  <div class="order-image relative">
                    <img :src="image.url" :alt="imageTitle(image)" />
                    <button
                      v-if="image.instruction"
                      type="button"
                      class="btn btn-secondary btn-icon position-absolute"
                      style="right: 15px; top: 6px;"
                      @click.prevent="showInstructionModal(image)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                        class="kt-svg-icon"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <circle
                            fill="#000000"
                            opacity="0.3"
                            cx="12"
                            cy="12"
                            r="10"
                          ></circle>
                          <rect
                            fill="#000000"
                            x="11"
                            y="10"
                            width="2"
                            height="7"
                            rx="1"
                          ></rect>
                          <rect
                            fill="#000000"
                            x="11"
                            y="7"
                            width="2"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="caption pt-1 text-center bg-secondary">
                    <p class="text-truncate">
                      {{ imageComplexity(image) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="image-instruction-modal"
      height="auto"
      class="image-instruction-modal"
      :clickToClose="false"
    >
      <div class="kt-portlet">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">Instructions</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div v-if="modalInstruction && modalInstruction.instruction">
            {{ modalInstruction.instruction }}
          </div>
        </div>

        <div class="kt-portlet__foot">
          <div class="kt-form__actions kt-form__actions--right">
            <div class="row">
              <div class="col kt-align-right">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click.prevent="hideInstructionModal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <stripe-payment-modal
      v-if="site.payment_gateway === 'stripe'"
    ></stripe-payment-modal>
  </BaseLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import AddonTypes from "@/types/addons.js";
import DateTimeMixin from "@/mixins/DateTime.js";
import MoneyFormatMixin from "@/mixins/currency.js";
import OrderStatusMixin from "@/mixins/orderStatus.js";
import EditOrderMenuMixin from "@/mixins/EditOrderMenu.js";
import BaseLayout from "@/layouts/BaseLayout.vue";
import StripePaymentModal from "@/components/StripePaymentModal.vue";
import MessagesModal from "@/components/MessagesModal.vue";
import DownloadOrderResultFiles from "@/components/DownloadOrderResultFiles.vue";
//import OrderDetailImage from "@/components/OrderDetailImage.vue";
import { nl2br } from "@/helpers/support.js";
import OrderStatus from "@/types/orderStatus.js";

export default {
  name: "Home",
  components: {
    BaseLayout,
    StripePaymentModal,
    MessagesModal,
    DownloadOrderResultFiles,
    //OrderDetailImage,
  },
  mixins: [DateTimeMixin, MoneyFormatMixin, OrderStatusMixin, EditOrderMenuMixin],
  data() {
    return {
      order: null,
      AddonTypes: AddonTypes,
      modalInstruction: null,
    };
  },
  computed: {
    ...mapGetters({
      site: "site/site",
      user: "auth/user",
    }),
    orderInstruction() {
      return nl2br(this.order.instruction);
    },

    featuredImage() {
      if (this.order && this.order?.images.length) {
        return this.order.images[0];
      }
      return null;
    },

    marginAddon() {
      return this.order?.addons[AddonTypes.Margin] || null;
    },
    websizeAddon() {
      return this.order?.addons[AddonTypes.Websize] || null;
    },
    isQuoteSubmitted() {
      return this.order?.status === OrderStatus.QuoteSubmitted;
    },
    showInvoiceBtn() {
      return this.order?.status !== OrderStatus.QuoteRequested;
    },
    showPayBtn() {
      return ! this.user.is_postpaid 
        && (this.isDraft(this.order) || this.isPending(this.order));
    },
  },
  created() {
    axios.get("orders/" + this.$route.params.id).then((response) => {
      this.order = response.data;
    });
  },

  beforeRouteLeave(to, from, next) {
    if (!this.$refs?.messageModal?.isSendingMsg) {
      next();
      return;
    }

    this.$swal({
      title: "⚠️ Message Sending In-progress",
      text:
        "You are currently in the middle of sending a message, if you leave it will not be submitted.",
      showCancelButton: true,
      confirmButtonText: "Leave",
      cancelButtonText: "Cancel",
    }).then((response) => {
      if (response.isConfirmed) {
        next();
        return;
      }
    });
  },

  methods: {
    ...mapActions({
      createStripePaymentIntent: "order/createStripePaymentIntent",
      acceptQuotationForPostpaidClient: "order/acceptQuotationForPostpaidClient",
      setClientSecret: "order/setClientSecret",
    }),
    imageComplexity(image) {
      if(image.complexity && this.order?.status !== OrderStatus.QuoteRequested) {
        return image.complexity.title
      }
      return "Not sure";
    },
    placeStripeOrder() {
      this.createStripePaymentIntent({
        order_id: this.order.id,
      })
        .then((response) => {
          this.setClientSecret({
            clientSecret: response.data.client_secret,
          });
          this.$modal.show("stripe-payment-modal");
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    acceptQuotation() {
      this.acceptQuotationForPostpaidClient(this.order.id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Quotation accepted successfully",
          }).then(() => {
            this.$router.push({ name: "home" });
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    imageTitle(image) {
      return image?.title || image.original_name || "";
    },

    getIcon(service) {
      const serviceTypes = {
        ["Shadows"]: "flaticon-background",
        ["Delivery Formats"]: "flaticon-pie-chart",
        ["Delivery Types"]: "flaticon-security",
        ["default"]: "flaticon2-checking",
      };

      return serviceTypes[service] || serviceTypes["default"];
    },

    showInstructionModal(instruction) {
      this.modalInstruction = instruction;
      this.$modal.show("image-instruction-modal");
    },
    hideInstructionModal() {
      this.$modal.hide("image-instruction-modal");
    },
  },
};
</script>

<style>
select.form-control {
  padding: 0.65rem 1rem !important;
  border: 1px solid #e2e5ec !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.hover:hover {
  background-color: #eee;
}
.order-image img {
  padding: 6px 4px;
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  height: 170px;
  border: 1px solid #cccccc;
}

.kt-portlet__body{
  position: relative;
}

.order-details-title{
  width: 100%;
}
.image-instruction-modal .kt-portlet {
  margin-bottom: 0;
}
</style>
